export default "__VITE_ASSET__342ad3ab__"